import React from 'react';
import SapConsultingIntro from '../components/SapConsultingIntro/SapConsultingIntro';
import SapConsultingWhyChoose from '../components/SapConsultingWhyChoose/SapConsultingWhyChoose';
import SapConsultingBenefits from '../components/SapConsultingBenefits/SapConsultingBenefits';
import CtaSection from '../components/CtaSection/CtaSection'; // Import CTA

const SapConsultingPage = () => {
  return (
    <>
      <SapConsultingIntro />
      <SapConsultingWhyChoose />
      <SapConsultingBenefits />
      <CtaSection />
    </>
  );
};

export default SapConsultingPage;
